import { render, staticRenderFns } from "./CommercialHistoryChart.vue?vue&type=template&id=bdc96c1c&"
import script from "./CommercialHistoryChart.vue?vue&type=script&lang=js&"
export * from "./CommercialHistoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports